import { Component, OnInit } from '@angular/core';
import { ToolService } from '../../services/tool/tool.service';

@Component({
  selector: 'app-sample',
  templateUrl: './sample.component.html',
  styleUrls: ['./sample.component.scss']
})
export class SampleComponent implements OnInit {

  constructor(
    public toolService: ToolService,
  ) { }

  ngOnInit(): void {
  }

}
